module.exports = __webpack_public_path__ + "assets/img/21_1121_big.de84e912.jpg";